"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLegacyRpcSdk = void 0;
var build_legacy_rpc_sdk_1 = require("./build-legacy-rpc-sdk");
Object.defineProperty(exports, "buildLegacyRpcSdk", { enumerable: true, get: function () { return build_legacy_rpc_sdk_1.buildLegacyRpcSdk; } });
//# sourceMappingURL=index.js.map